

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
          element.classList.remove('variant-media-show');
        });
        activeMedia.classList.add('is-active');
        activeMedia.classList.add('variant-media-show');


       
        /*if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }*/

        this.preventStickyHeader();

        const windowWidth = window.innerWidth;
        if(windowWidth < '769'){
          window.setTimeout(() => {
            // Bring the new media into view WITHOUT moving the page.
            //
            // This used to call activeMedia.scrollIntoView({ behavior: 'smooth' }), which
            // scrolls the DOCUMENT vertically. The gallery sits above the variant picker, so
            // choosing a variant yanked the shopper upward and away from the buy button —
            // reported as the page "pulling you up". It only ever happened under 769px, which
            // is why it read as a mobile problem.
            //
            // The mobile gallery is a horizontal slider, so scrolling its track on the x-axis
            // shows the right image and leaves the page's scroll position alone. Doing it
            // unconditionally also covers the case the old code handled with scrollIntoView:
            // a gallery with no thumbnails, where the first branch was skipped entirely.
            const track = activeMedia.parentElement;
            if (track && typeof track.scrollTo === 'function') {
              track.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
            }
          });


        const allLis = document.querySelectorAll('.product__media-list > li');
        const dots = document.querySelectorAll('.pi-slider-dot');

        // reset first
        dots.forEach(dot => dot.classList.remove('is-hidden'));

        allLis.forEach((li, index) => {
          if (
            li.classList.contains('variant-media') &&
            !li.classList.contains('is-active')
          ) {
            // li index is 0-based → convert to 1-based
            const dotIndex = index + 2;

            const dot = document.querySelector(
              `.pi-slider-dot[data-index="${dotIndex}"]`
            );

            if (dot) {
              dot.classList.add('is-hidden');
            }
          }
        });


        }


        //  window.setTimeout(() => {
        //    activeMedia.classList.remove('is-active');
        //    void activeMedia.offsetWidth; // force reflow
        //    activeMedia.classList.add('is-active');
        //  });

       
        this.elements.viewer
          .querySelectorAll('.product__media-item.is-animating')
          .forEach(el => el.classList.remove('is-animating'));

       
        requestAnimationFrame(() => {
          activeMedia.classList.add('is-animating');

          setTimeout(() => {
            activeMedia.classList.remove('is-animating');
          }, 500);
        });

       
                
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
     setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
